import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, FormControl } from '@mui/material';
import { withStyles } from '@mui/styles';
import classNames from 'classnames';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { withTranslation } from 'react-i18next';
import { applyFilters, resetApplyFilters, updateFilters } from '../../../actions/virtualMachinesFilters';
import { fetchVMs } from '../../../actions';
import { VirtualMachineIdTypeahead, VirtualMachineTypeahead } from '../Typeahead';
import { mapVMFiltersStateToQuery } from '../../../utils';

const styles = theme => ({
    button: {
        margin: theme.spacing(0.5),
        marginTop: theme.spacing(2),
        flexGrow: 1
    },
    filterForm: {
        padding: theme.spacing(1)
    },
    controlButtons: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-around'
    },
    switchForm: {
        paddingLeft: 5,
        '& label': {
            marginRight: 5,
            marginLeft: 0,
            flexDirection: 'column',
            justifyContent: 'flex-end'
        }
    }
});

class VirtualMachineFilter extends Component {
    state = {
        vmIdValue: '',
    };

    handleChange = e => {
        this.props.updateFilters({
            ...this.props.VMFilters,
            [e.target.name]: e.target.value
        });
    };

    handleResetClick = async () => {
        await this.props.resetApplyFilters();

        const filters = mapVMFiltersStateToQuery(this.props.VMFilters);

        this.props.fetchVMs(filters);
    };

    handleClickApply = e => {
        e.preventDefault();
        const filters = mapVMFiltersStateToQuery(this.props.VMFilters);
        this.props.applyFilters(this.props.VMFilters);
        this.props.fetchVMs(filters);
    };

    handleChangeMultiSuggestion = name => suggestion => {
        this.props.updateFilters({
            ...this.props.VMFilters,
            [name]: suggestion
        });
    };

    handleChangeVmIdValue = value => {
        this.setState({ vmIdValue: value });
    }

    handleAddIdMultiInput = value => {
        this.props.updateFilters({
            ...this.props.VMFilters,
            virtualMachineIds: [...this.props.VMFilters.virtualMachineIds, { value }],
        });
        this.setState({ vmIdValue: '' });
    }

    handleDeleteItemIdMultiInput = values => {
        this.props.updateFilters({
            ...this.props.VMFilters,
            virtualMachineIds: values,
        });
    }

    render() {
        const { classes, VMFilters, t } = this.props;
        const { vmIdValue } = this.state;

        return (
            <div
                className={classNames('filter', classes.filterForm)}
            >
                <FormControl
                    fullWidth
                    margin="dense"
                >
                    <VirtualMachineTypeahead
                        margin="none"
                        value={VMFilters.virtualMachines}
                        labelId="vmTitle"
                        name="name"
                        onChangeSuggestion={this.handleChangeMultiSuggestion('virtualMachines')}
                        t={t}
                    />
                </FormControl>

                <FormControl
                    fullWidth
                    margin="dense"
                >
                    <VirtualMachineIdTypeahead
                        value={vmIdValue}
                        onChangeValue={this.handleChangeVmIdValue}
                        values={VMFilters.virtualMachineIds}
                        onChangeMultiInput={this.handleAddIdMultiInput}
                        onDeleteValue={this.handleDeleteItemIdMultiInput}
                        t={t}
                    />
                </FormControl>

                <div className={classes.controlButtons}>
                    <Button
                        variant="contained"
                        className={classes.button}
                        onClick={this.handleResetClick}
                    >
                        {t('reset')}
                    </Button>
                    <Button
                        variant="contained"
                        className={classes.button}
                        color="secondary"
                        type="submit"
                        onClick={this.handleClickApply}
                    >
                        {t('apply')}
                    </Button>
                </div>
            </div>
        );
    }
}

VirtualMachineFilter.propTypes = {
    VMFilters: PropTypes.shape({
        locations: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.number,
            }),
        ),
        strict: PropTypes.bool,
        virtualMachines: PropTypes.array,
    }),
    classes: PropTypes.shape({
        filterForm: PropTypes.string,
        controlButtons: PropTypes.string,
        button: PropTypes.string,
    }),
    fetchVMs: PropTypes.func,
    updateFilters: PropTypes.func,
    applyFilters: PropTypes.func,
    resetApplyFilters: PropTypes.func,
};

const mapStateToProps = ({ VMFilters, infrastructure }) => ({
    VMFilters: VMFilters.currentFilters,
    locations: infrastructure.locations[0]
});

export default compose(
    withTranslation('virtualmachines'),
    connect(mapStateToProps, {
        fetchVMs,
        updateFilters,
        applyFilters,
        resetApplyFilters
    }),
    withStyles(styles)
)(VirtualMachineFilter);
